<div class="app-field" [class.app-field--error]="hasError">

  <label *ngIf="label" class="app-field__label">
    {{ label }}
    <span *ngIf="required" class="app-field__required" aria-hidden="true">*</span>
  </label>

  <div class="app-field__control">
    <ng-content></ng-content>
  </div>

  <small *ngIf="hasError" class="app-field__error" role="alert">
    <i class="pi pi-exclamation-circle"></i>
    {{ errorMessage }}
  </small>

  <small *ngIf="hint && !hasError" class="app-field__hint">{{ hint }}</small>

</div>
